/**
 * Marke im Fragment beim App-Wechsel (`app_oeffnen`): die Ziel-Huelle oeffnet Jane sofort
 * wieder. Nur Fragment, nie Query — das Fragment erreicht weder Server noch Cache.
 */
export type JaneMarke = "offen" | "anruf";
const MARKEN: readonly string[] = ["offen", "anruf"] satisfies JaneMarke[];

export function mitJaneMarke(ziel: string, marke: JaneMarke | null): string {
  return marke ? `${ziel}#jane=${marke}` : ziel;
}

/** Liest `jane=` aus dem Fragment; fremde Teile (`&`-getrennt) bleiben unveraendert stehen. */
export function ohneJaneMarke(hash: string): { marke: JaneMarke | null; hash: string } {
  const teile = hash.replace(/^#/, "").split("&").filter(Boolean);
  const i = teile.findIndex((t) => t.startsWith("jane=") && MARKEN.includes(t.slice(5)));
  if (i < 0) return { marke: null, hash };
  const marke = teile[i].slice(5) as JaneMarke;
  teile.splice(i, 1);
  return { marke, hash: teile.length > 0 ? `#${teile.join("&")}` : "" };
}

/**
 * Apps, die ihre Adresse per `replaceState` ohne Fragment umschreiben, verlieren `#jane=offen`, bevor
 * `AppLayout` es liest (dort erst nach `janeWirt`). Das Vorpaint-Skript (`lib/jane-vorpaint.ts`) sichert die
 * Marke deshalb im ersten synchronen Schritt in sessionStorage dieses Ursprungs; `AppLayout` nimmt sie von dort.
 */
export const JANE_MARKE_SCHLUESSEL = "jw-jane-marke";
export const JANE_MARKE_GUELTIG_MS = 60_000;

/** Liest und LOESCHT die gesicherte Marke; abgelaufen oder kaputt gilt sie nicht. */
export function gesicherteJaneMarke(speicher: Pick<Storage, "getItem" | "removeItem">, jetzt: number): JaneMarke | null {
  try {
    const roh = speicher.getItem(JANE_MARKE_SCHLUESSEL);
    speicher.removeItem(JANE_MARKE_SCHLUESSEL);
    if (!roh) return null;
    const [marke, zeit] = roh.split("@");
    const t = Number(zeit);
    if (!MARKEN.includes(marke) || !Number.isFinite(t) || jetzt < t || jetzt - t > JANE_MARKE_GUELTIG_MS) return null;
    return marke as JaneMarke;
  } catch {
    return null;
  }
}
